Postlogin = (function (my) {
    my.Lesson = (function (self) {
        let lessonId = null;
        let userLessonId = null;
        let vjsSectionId = null;
        let numberOfSegments = 0;
        let currentSegmentId = null;
        let furthestSegmentId = null;
        let currentSegmentIndex = 1;
        let furthestSegmentIndex = 0;
        let gradeBand = '';
        let soundEnabled = true;
        let closedCaptioning = false;
        let segments = [];
        const segmentIndexMap = {};
        const loadedSegments = [];
        let segmentUrl = null;
        let lessonUrl = null;
        let captionBuffer = null;
        let isDragging = false;
        let draggingTimeout = null;
        let inF11FullscreenMode = false;
        let inPlatformFullscreenMode = false;
        let inFullscreenMode = false;
        let inDoubleFullscreenMode = false;
        const queuedSounds = {};
        const playingSounds = {};
        let progress = null;
        let currentSound;

        // play/pause button
        const pausePath = 'M11,10 L18,13.74 18,22.28 11,26 M18,13.74 L26,18 26,18 18,22.28';
        const playPath = 'M11,10 L17,10 17,26 11,26 M20,10 L26,10 26,26 20,26';

        const sounds = {
            swoosh: `${Jr.getAssetsRoot()}/static/sounds/swoosh.mp3`,
            pick_up: `${Jr.getAssetsRoot()}/static/sounds/pick-up.mp3`,
            click: `${Jr.getAssetsRoot()}/static/sounds/click.wav`,
            glow: `${Jr.getAssetsRoot()}/static/sounds/glow.mp3`,
            incorrect: `${Jr.getAssetsRoot()}/static/sounds/incorrect.mp3`,
            correct: `${Jr.getAssetsRoot()}/static/sounds/correct.mp3`,
            place: `${Jr.getAssetsRoot()}/static/sounds/place2.mp3`,
            placing: `${Jr.getAssetsRoot()}/static/sounds/placing.mp3`,
            cheers: `${Jr.getAssetsRoot()}/static/sounds/cheers.mp3`,
            flip: `${Jr.getAssetsRoot()}/static/sounds/flip.mp3`,
            pilf: `${Jr.getAssetsRoot()}/static/sounds/pilf.mp3`,
            'error-buzz': `${Jr.getAssetsRoot()}/static/sounds/error-buzz.mp3`,
            'hotspot-click': `${Jr.getAssetsRoot()}/static/sounds/hotspot-click.mp3`,
        };

        const speechSounds = {};

        self.init = function () {
            lessonId = $('#page-container').data('lesson-id');
            userLessonId = $('#page-container').data('user-lesson-id');
            lessonUrl = $('#page-container').data('lesson-url');
            segmentUrl = $('#page-container').data('segment-url');

            self.loadSettings();
            self.initEvents();
            self.loadLesson();

            setTimeout(() => {
                // initialize all of the audio files we need
                $.each(sounds, (i, soundFile) => {
                    sounds[i] = new Audio(soundFile);
                });
            }, 100);

            $(document).on('keydown', (event) => {
                // F11
                if (event.which === 122) {
                    event.preventDefault();
                    self.setInF11FullscreenMode(!self.isInF11FullscreenMode());
                    self.setInPlatformFullscreenMode(!self.isInPlatformFullscreenMode());
                    self.toggleFullScreen();
                }
            });

            const screenChangeEvents = 'webkitfullscreenchange mozfullscreenchange fullscreenchange MSFullscreenChange';
            $(document).on(screenChangeEvents, () => {
                const engageFullscreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;

                if (engageFullscreen) {
                    // engaging full screen
                    if (self.isInFullscreenMode()) {
                        // if we're engaging fullscreen mode, and we're already in fullscreen mode...
                        // we must be fullscreening a video!
                        self.setInDoubleFullscreenMode(true);
                    } else {
                        // otherwise, we're just going fullscreen platform OR fullscreen video
                        self.setInFullscreenMode(true);
                        self.setInDoubleFullscreenMode(false);
                    }
                } else {
                    // disengaging full screen
                    self.setInFullscreenMode(false);
                    self.setInF11FullscreenMode(false);
                    self.setInPlatformFullscreenMode(false);
                    self.setInDoubleFullscreenMode(false);
                }
            });
        };

        self.loadLesson = function () {
            // fetch the lesson data
            $.getJSON(lessonUrl, (data) => {
                const lesson = data.data;

                vjsSectionId = lesson.vjs_section_id;
                numberOfSegments = +lesson.number_of_segments;
                currentSegmentId = lesson.current_segment_id;
                furthestSegmentId = lesson.furthest_segment_id;
                currentSegmentIndex = lesson.current_segment_index;
                furthestSegmentIndex = lesson.furthest_segment_index;
                gradeBand = lesson.grade_band;
                progress = lesson.progress;

                segments = lesson.segments;

                $.each(segments, (i, segment) => {
                    segmentIndexMap[segment.segment_id] = +i;
                });

                // create progress menu
                self.Progress.populate(segments);

                if (typeof progress !== 'undefined') {
                    self.Progress.updatePercentComplete(progress);
                }

                // load the current segment
                self.loadSegment(lesson.current_segment_data);

                // go to the current segment
                self.goToSegment(currentSegmentIndex);
            });
        };

        self.loadSegment = function (segmentData) {
            let thisSegment = null;

            const segmentIndex = segmentIndexMap[segmentData.segment_id];
            if (typeof loadedSegments[segmentIndex] !== 'undefined') {
                return;
            }

            /* eslint-disable no-param-reassign */
            // initialize it
            segmentData.segment_index = segmentIndex;
            segmentData.first = segmentIndex === 1;
            segmentData.last = segmentIndex === numberOfSegments;
            /* eslint-enable no-param-reassign */

            switch (segmentData.type_slug) {
                case 'video':
                    thisSegment = new self.VideoSegment(segmentData);
                    break;
                case 'activity':
                    switch (segmentData.activity_type_slug) {
                        case 'image-scramble':
                            thisSegment = new self.ImageScramble(segmentData);
                            break;
                        case 'matching':
                            thisSegment = new self.Matching(segmentData);
                            break;
                        case 'memory':
                            thisSegment = new self.Memory(segmentData);
                            break;
                        case 'ordering':
                            thisSegment = new self.Ordering(segmentData);
                            break;
                        case 'word-scramble':
                            thisSegment = new self.WordScramble(segmentData);
                            break;
                        case 'bingo':
                            thisSegment = new self.Bingo(segmentData);
                            break;
                        case 'true-false':
                            thisSegment = new self.TrueFalse(segmentData);
                            break;
                        case 'multiple-choice':
                            thisSegment = new self.MultipleChoice(segmentData);
                            break;
                        case 'hotspots':
                            thisSegment = new self.Hotspots(segmentData);
                            break;
                        case 'rate-your-interest':
                            thisSegment = new self.RateYourInterest(segmentData);
                            break;
                        case 'categorizing':
                            thisSegment = new self.Categorizing(segmentData);
                            break;
                        case 'written-response':
                            thisSegment = new self.WrittenResponse(segmentData);
                            break;
                        default:
                            break;
                    }
                    break;
                case 'html-content':
                    thisSegment = new self.HTMLContentSegment(segmentData);
                    break;
                default:
                    break;
            }

            loadedSegments[segmentIndex] = thisSegment;
            loadedSegments[segmentIndex].init();
        };

        // Load any saved preferences (sound, closed captioning status)
        self.loadSettings = function () {
            // load cookies to see if we should remember any settings
            const soundCookie = Cookies.get('sound_enabled');
            if (typeof soundCookie !== 'undefined') {
                soundEnabled = soundCookie === 'true';
                self.updateSoundIcon();
            }

            const ccCookie = Cookies.get('closed_captioning');
            if (typeof ccCookie !== 'undefined') {
                closedCaptioning = ccCookie === 'true';
                self.updateCCIcon();
            }
        };

        self.initEvents = function () {
            $('body').on('click', '.skip-video', function () {
                $(this).blur(); // remove focus from this element
                loadedSegments[currentSegmentIndex].setCompleted();
                self.nextSegment();
            });
            $('body').on('click', '#next-segment', function () {
                $(this).blur(); // remove focus from this element
                self.nextSegment();
            });
            $('body').on('click', '#previous-segment', function () {
                $(this).blur(); // remove focus from this element
                self.previousSegment();
            });

            $('body').on('click', '#beep-9-modal:not(.activated)', function () {
                if (!$(this).hasClass('activated')) {
                    self.Popup.showHelp(
                        loadedSegments[currentSegmentIndex],
                        0,
                        () => {
                            loadedSegments[currentSegmentIndex].speakQuestion(500);
                        },
                        true,
                    );
                }
            });

            $('body').on('click', '.has-audio', function (e) {
                const sound = $(this).attr('data-audio');
                e.stopPropagation();
                e.preventDefault();
                if (!isDragging) {
                    self.playSound(sound);
                }

                return false;
            });

            $('body').on('click', '.option-audio', function (e) {
                const sound = $(this).attr('data-audio');
                e.stopPropagation();
                e.preventDefault();
                if (!isDragging) {
                    self.playSound(sound);
                }

                return false;
            });

            // space bar triggers pause/play functionality
            $(document).keypress((e) => {
                if ((e.which && e.which === 32) || (e.keyCode && e.keyCode === 32)) {
                    loadedSegments[currentSegmentIndex].togglePlay();

                    return true;
                }

                return true;
            });

            $('#segment-controls').on('click', '.segment-pause-play-button', () => {
                loadedSegments[currentSegmentIndex].togglePlay();
            });
            $('#segment-controls').on('click', '.segment-replay-button', () => {
                // hideNextButton();
                loadedSegments[currentSegmentIndex].replay(true);
            });

            $('#segment-controls').on('click', '.segment-fullscreen-button', () => {
                self.setInPlatformFullscreenMode(!self.isInPlatformFullscreenMode());
                self.toggleFullScreen();
            });

            $('#segment-controls').on('click', '.segment-mute-button', () => {
                soundEnabled = !soundEnabled;
                Cookies.set('sound_enabled', soundEnabled);
                self.updateSoundIcon();
                loadedSegments[currentSegmentIndex].mute(soundEnabled);

                // if we just muted sound, and CC is off, turn CC on...
                if (!soundEnabled && !closedCaptioning) {
                    self.toggleClosedCaptioning();
                }
            });

            $('#segment-controls').on('click', '.segment-cc-button', () => {
                self.toggleClosedCaptioning();
            });
        };

        self.toggleClosedCaptioning = function () {
            closedCaptioning = !closedCaptioning;
            Cookies.set('closed_captioning', closedCaptioning);
            self.updateCCIcon();
            loadedSegments[currentSegmentIndex].toggleCC(closedCaptioning);
        };

        self.updateSoundIcon = function () {
            if (soundEnabled) {
                $('#segment-controls .segment-mute-button .fa-ban').fadeOut();
                $('body').removeClass('sound-disabled');
            } else {
                $('#segment-controls .segment-mute-button .fa-ban').fadeIn();
                $('body').addClass('sound-disabled');
            }
        };

        self.updateCCIcon = function () {
            if (closedCaptioning) {
                $('#segment-controls .segment-cc-button .fa-ban').fadeOut();
                $('#page-container').addClass('cc-enabled');
            } else {
                $('#cc-container').removeClass('shown');
                $('#segment-controls .segment-cc-button .fa-ban').fadeIn();
                $('#page-container').removeClass('cc-enabled');
            }
        };

        self.resetPlayPause = function () {
            const $elem = $('#segment-controls #pause-play-animation');

            if ('beginElement' in $elem.get(0)) {
                $elem.attr({
                    from: pausePath,
                    to: playPath,
                });
                $elem[0].beginElement();
            }
        };

        self.setPlayState = function (playing) {
            const $elem = $('#segment-controls #pause-play-animation');

            if ('beginElement' in $elem.get(0)) {
                $elem.attr({
                    from: playing ? pausePath : playPath,
                    to: playing ? playPath : pausePath,
                });
                $elem[0].beginElement();
            } else {
                $elem.parent().attr('path', playing ? playPath : pausePath);
            }

            $(`.segment-pause-play-button .fa-${playing ? 'play' : 'pause'}`).hide();
            $(`.segment-pause-play-button .fa-${playing ? 'pause' : 'play'}`).show();
        };

        self.nextSegment = function () {
            self.goToSegment(parseInt(currentSegmentIndex, 10) + 1);
        };

        self.previousSegment = function () {
            self.goToSegment(parseInt(currentSegmentIndex, 10) - 1);
        };

        self.goToSegment = function (segmentIndex) {
            self.stopAllSounds();
            self.Popup.hideModal();

            if (segmentIndex < 1 || typeof segments[segmentIndex] === 'undefined') {
                return;
            }

            // hide closed captioning container
            $('#cc-container').removeClass('shown');

            // has this segment been fetched and initialized yet? if not...
            if (typeof loadedSegments[segmentIndex] === 'undefined') {
                // fetch the current segment
                $.ajax({
                    url: segmentUrl.replace(':segment_id', segments[segmentIndex].segment_id),
                    dataType: 'json',
                    async: false,
                    success(data) {
                        self.loadSegment(data.data);
                    },
                    error(jqXHR, textStatus, errorThrown) {
                        // Error tracking removed
                    },
                });
            }

            if (typeof loadedSegments[segmentIndex] === 'undefined') {
                // Error tracking removed
            }

            $('#clouds-background-container').css(
                'backgroundPosition',
                `-${(segmentIndex - 1) * 280}px 260px, -${(segmentIndex - 1) * 100}px 260px, -${(segmentIndex - 1) * 180}px 260px, -${
                    (segmentIndex - 1) * 70
                }px 260px`,
            );

            if (parseInt(segmentIndex, 10) > parseInt(numberOfSegments, 10)) {
                window.location.replace(`/career-central/cluster/${vjsSectionId}/`);

                return;
            }

            self.Progress.selectSegment(segmentIndex);
            self.pauseCurrentSegment();

            const previousSegmentIndex = currentSegmentIndex;
            currentSegmentIndex = segmentIndex;
            currentSegmentId = segments[currentSegmentIndex].segment_id;
            const nextSegmentIndex = parseInt(currentSegmentIndex, 10) + 1;

            if (currentSegmentIndex > previousSegmentIndex) {
                loadedSegments[previousSegmentIndex].moveOutLeft();
                loadedSegments[previousSegmentIndex].hide();
                loadedSegments[currentSegmentIndex].moveInLeft();
                loadedSegments[currentSegmentIndex].show();
            } else {
                loadedSegments[previousSegmentIndex].moveOutRight();
                loadedSegments[previousSegmentIndex].hide();
                loadedSegments[currentSegmentIndex].moveInRight();
                loadedSegments[currentSegmentIndex].show();
            }

            if (typeof loadedSegments[nextSegmentIndex] === 'undefined' && nextSegmentIndex < numberOfSegments) {
                // pre-fetch the next segment
                $.ajax({
                    url: segmentUrl.replace(':segment_id', segments[nextSegmentIndex].segment_id),
                    dataType: 'json',
                    async: true,
                    success(data) {
                        self.loadSegment(data.data);
                    },
                });
            }
        };

        self.showNextButton = function () {
            $('#next-segment').addClass('enabled');
        };

        self.hideNextButton = function () {
            $('#next-segment').removeClass('enabled');
        };

        self.soundEnabled = function () {
            return soundEnabled;
        };

        self.closedCaptioningEnabled = function () {
            return closedCaptioning;
        };

        self.renderClosedCaptioning = function ($el, sectionData) {
            const $container = $el.find('.text-container');
            $container.html('');

            if (!sectionData || sectionData == null) {
                if (captionBuffer == null) {
                    captionBuffer = setTimeout(() => {
                        $('#cc-container .text-container').html('');
                        $('#cc-container').removeClass('shown');
                    }, 2000);
                }
            } else {
                // if we had set up a timeout, clear it
                if (captionBuffer != null) {
                    clearTimeout(captionBuffer);
                }
                if (closedCaptioning) {
                    $el.addClass('shown');
                }
                $el.attr('data-character', sectionData.character !== '' ? sectionData.character : '');
                $el.attr('data-position', sectionData.position === 'right' ? 'right' : 'left');

                $container.html(`<p>${sectionData.text}</p>`);
            }
        };

        //  * Play the specified sound effect at the specified volume.
        //  * (Clones the sound)
        self.playSoundEffect = function (name, volume = 1, delay = 0) {
            const thisSound = sounds[name].cloneNode(false);
            thisSound.volume = soundEnabled ? volume : 0;

            if (soundEnabled) {
                thisSound.addEventListener(
                    'ended',
                    function () {
                        $(this).remove();
                    },
                    false,
                );
                if (delay > 0) {
                    setTimeout(() => {
                        const isPlaying = thisSound.currentTime > 0 && !thisSound.paused && !thisSound.ended && thisSound.readyState > 2;

                        if (!isPlaying) {
                            thisSound.play();
                        }
                    }, delay);
                } else {
                    const isPlaying = thisSound.currentTime > 0 && !thisSound.paused && !thisSound.ended && thisSound.readyState > 2;

                    if (!isPlaying) {
                        thisSound.play();
                    }
                }
            }

            return thisSound;
        };

        self.preloadSound = function (src) {
            if (!src) {
                return;
            }
            let sound = document.createElement('audio');
            if ('src' in sound) {
                sound.autoPlay = false;
            } else {
                sound = document.createElement('bgsound');
                sound.volume = -10000;
            }
            sound.src = src;
            $('body').append(sound);
            speechSounds[src] = sound;

            return speechSounds[src];
        };

        //  * Play the specified sound at the specified volume.
        //  * (Clones the sound)
        self.playSound = function (url, delay = 0, callback = null, onEnd = null) {
            let thisSound;

            self.stopAllSounds();

            let src = url;
            if (document.location.protocol === 'https:') {
                src = src.replace('http://', 'https://');
            }

            if (typeof speechSounds[src] !== 'undefined') {
                thisSound = speechSounds[src];
            } else {
                thisSound = new Audio(src);
                speechSounds[src] = thisSound;
            }

            thisSound = thisSound.cloneNode(false);
            thisSound.volume = soundEnabled ? 1 : 0;

            if (soundEnabled) {
                const safetyTimeoutId = setTimeout(() => {
                    $('#beep-9-modal .btn-continue .progress').remove();
                    $('#beep-9-modal .btn-continue').prop('disabled', false);
                }, 10000);

                thisSound.addEventListener('play', () => {
                    const { duration } = thisSound;
                    $('#beep-9-modal .btn-continue .progress').css('transition', `all ${duration}s ease-in-out`);
                    $('#beep-9-modal .btn-continue .progress').addClass('complete');
                });

                thisSound.addEventListener('loadedmetadata', () => {
                    $('#beep-9-modal .btn-continue').append($('<div class="progress"></div>'));

                    if (delay > 0) {
                        queuedSounds[src] = setTimeout(() => {
                            currentSound = thisSound;
                            delete queuedSounds[src];
                            playingSounds[src] = thisSound;
                            thisSound.play();
                            if (typeof callback === 'function') {
                                callback();
                            }
                        }, delay);
                    } else {
                        currentSound = thisSound;
                        playingSounds[src] = thisSound;
                        thisSound.play();
                        if (typeof callback === 'function') {
                            callback();
                        }
                    }
                });
                thisSound.addEventListener(
                    'ended',
                    function () {
                        const soundSrc = $(this).attr('src');
                        if (currentSound === playingSounds[soundSrc]) {
                            currentSound = null;
                        }
                        delete playingSounds[soundSrc];
                        $(this).remove();
                        if (typeof onEnd === 'function') {
                            onEnd();
                        }
                        setTimeout(() => {
                            $('#beep-9-modal .btn-continue .progress').remove();
                        }, 500);
                        clearTimeout(safetyTimeoutId);
                    },
                    false,
                );
            } else {
                if (typeof callback === 'function') {
                    callback();
                }
                if (typeof onEnd === 'function') {
                    onEnd();
                }
            }

            return thisSound;
        };

        self.pauseCurrentSound = function () {};

        self.pauseSound = function (sound) {
            if (sound != null) {
                const isPlaying = sound.currentTime > 0 && !sound.paused && !sound.ended && sound.readyState > 2;

                if (isPlaying) {
                    sound.pause();
                }
            }
        };

        self.stopAllSounds = function (queued = true, playing = true) {
            if (queued) {
                // eslint-disable-next-line no-restricted-syntax
                for (const src in queuedSounds) {
                    if (typeof queuedSounds[src] !== 'undefined') {
                        clearTimeout(queuedSounds[src]);
                        delete queuedSounds[src];
                    }
                }
            }
            if (playing) {
                // eslint-disable-next-line no-restricted-syntax
                for (const src in playingSounds) {
                    if (typeof playingSounds[src] !== 'undefined') {
                        playingSounds[src].pause();
                        $(playingSounds[src]).remove();
                        delete playingSounds[src];
                    }
                }
            }
        };

        self.getCurrentSegmentId = function () {
            return currentSegmentId;
        };

        self.getCurrentSegment = function () {
            return loadedSegments[currentSegmentIndex];
        };

        self.getFurthestSegmentId = function () {
            return furthestSegmentId;
        };

        // possibly unused? when converting, this one was not exported, and not used in the current file.
        self.setCurrentSegmentId = function (id) {
            currentSegmentId = id;
        };

        self.getCurrentSegmentIndex = function () {
            return currentSegmentIndex;
        };

        self.getFurthestSegmentIndex = function () {
            return furthestSegmentIndex;
        };

        // possibly unused? when converting, this one was not exported, and not used in the current file.
        self.setCurrentSegmentIndex = function (index) {
            currentSegmentIndex = index;
        };

        self.pauseCurrentSegment = function () {
            if (typeof loadedSegments[currentSegmentIndex] === 'undefined') {
                return false;
            }

            return loadedSegments[currentSegmentIndex].pause();
        };

        self.playCurrentSegment = function () {
            if (typeof loadedSegments[currentSegmentIndex] === 'undefined') {
                return false;
            }

            return loadedSegments[currentSegmentIndex].play();
        };

        self.getUserLessonId = function () {
            return userLessonId;
        };

        self.getLessonId = function () {
            return lessonId;
        };

        self.getVJSSectionID = function () {
            return vjsSectionId;
        };

        self.setDragging = function (dragging) {
            // I'm setting a delay on the toggling off of is_dragging
            // so that the click-to-speak-word thing doesn't fire
            if (dragging) {
                clearTimeout(draggingTimeout);
                isDragging = true;
            } else {
                // give a little buffer time
                draggingTimeout = setTimeout(() => {
                    isDragging = false;
                }, 500);
            }
        };

        self.isDragging = function () {
            return isDragging;
        };

        self.toggleFullScreen = function () {
            if (
                !document.fullscreenElement // alternative standard method
                && !document.mozFullScreenElement
                && !document.webkitFullscreenElement
                && !document.msFullscreenElement
            ) {
                // current working methods
                if (document.documentElement.requestFullscreen) {
                    document.documentElement.requestFullscreen();
                } else if (document.documentElement.msRequestFullscreen) {
                    document.documentElement.msRequestFullscreen();
                } else if (document.documentElement.mozRequestFullScreen) {
                    document.documentElement.mozRequestFullScreen();
                } else if (document.documentElement.webkitRequestFullscreen) {
                    document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            }
            self.updateFullscreenButton();
        };

        self.getGradeBand = function () {
            return gradeBand;
        };

        self.getAllSegments = function () {
            return JSON.stringify(segments);
        };

        self.getNumberOfSegments = function () {
            return numberOfSegments;
        };

        self.isInFullscreenMode = function () {
            return inFullscreenMode;
        };

        self.isInF11FullscreenMode = function () {
            return inF11FullscreenMode;
        };

        self.isInDoubleFullscreenMode = function () {
            return inDoubleFullscreenMode;
        };

        self.isInPlatformFullscreenMode = function () {
            return inPlatformFullscreenMode;
        };

        self.setInFullscreenMode = function (value) {
            inFullscreenMode = value;
        };

        self.setInF11FullscreenMode = function (value) {
            inF11FullscreenMode = value;
        };

        self.setInDoubleFullscreenMode = function (value) {
            inDoubleFullscreenMode = value;
        };

        self.setInPlatformFullscreenMode = function (value) {
            inPlatformFullscreenMode = value;
        };

        self.updateFullscreenButton = function () {
            if (inF11FullscreenMode || inPlatformFullscreenMode) {
                $('#segment-controls .segment-fullscreen-button').find('.fa-expand').hide();
                $('#segment-controls .segment-fullscreen-button').find('.fa-compress').show();
            } else {
                $('#segment-controls .segment-fullscreen-button').find('.fa-expand').show();
                $('#segment-controls .segment-fullscreen-button').find('.fa-compress').hide();
            }
        };

        self.completeCurrentSegment = function () {
            if (typeof loadedSegments[currentSegmentIndex] === 'undefined') {
                return false;
            }
            loadedSegments[currentSegmentIndex].setCompleted();

            return true;
        };

        self.solveCurrentSegment = function () {
            if (typeof loadedSegments[currentSegmentIndex] === 'undefined') {
                return false;
            }
            loadedSegments[currentSegmentIndex].solve();

            return true;
        };

        return self;
    }(my.Lesson || {}));

    return my;
}(Postlogin || {}));
